import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import { auth } from './auth';

export default function IssueForm({ onSave, editingIssue, onCancel }) {
  const [form, setForm] = useState({
    dateReported: '',
    byWhom: '',
    description: '',
    location: '',
    complianceRisk: '',
    priority: '',
    estimatedCost: '',
    fund: '',
    targetQtr: '',
    status: ''
  });

  useEffect(() => {
    if (editingIssue) {
      setForm(editingIssue);
    } else {
      setForm({
        dateReported: new Date().toISOString(), // Default to current date+time
        byWhom: '', description: '', location: '', complianceRisk: '',
        priority: '', estimatedCost: '', fund: 'ADMN', targetQtr: '', status: 'Open'
      });
      // Auto-fill By Whom for new issue
      async function fetchUserName(email) {
        if (!email) {
          setForm(f => ({ ...f, byWhom: '' }));
          return;
        }
        try {
          const usersSnapshot = await getDocs(collection(db, 'users'));
          let matchedName = '';
          usersSnapshot.forEach(doc => {
            const data = doc.data();
            if (data.email && data.email.toLowerCase() === email.toLowerCase()) {
              matchedName = data.name;
            }
          });
          setForm(f => ({ ...f, byWhom: matchedName || email.split('@')[0] }));
        } catch (e) {
          setForm(f => ({ ...f, byWhom: email.split('@')[0] }));
        }
      }
      const unsub = auth.onAuthStateChanged(user => {
        if (user && user.email) {
          fetchUserName(user.email);
        } else {
          setForm(f => ({ ...f, byWhom: '' }));
        }
      });
      return () => { if (unsub) unsub(); };
    }
  }, [editingIssue]);

  function handleChange(e) {
    const { name, value } = e.target;
    if (name === 'description' && value.length > 250) return;
    setForm(f => ({ ...f, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    onSave(form);
  }

  return (
    <form className="issue-form" onSubmit={handleSubmit}>
      <h2>{editingIssue ? 'Edit Issue' : 'Register Issue'}</h2>
      <label>Date Reported</label>
      <input type="text" name="dateReported" value={form.dateReported} readOnly />
      <label>By Whom</label>
      <input name="byWhom" value={form.byWhom} onChange={handleChange} required readOnly={!editingIssue} />
      <label>Issue Brief Description (max 250 chars)</label>
      <textarea name="description" value={form.description} onChange={handleChange} maxLength={250} required />
      <label>Location</label>
      <input name="location" value={form.location} onChange={handleChange} required />
      <label>Compliance Risk</label>
      <select name="complianceRisk" value={form.complianceRisk} onChange={handleChange} required>
        <option value="">Select</option>
        <option value="HIGH">HIGH</option>
        <option value="MEDIUM">MEDIUM</option>
        <option value="LOW">LOW</option>
      </select>
      <label>Priority</label>
      <select name="priority" value={form.priority} onChange={handleChange} required>
        <option value="">Select</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
      <label>Estimated Cost</label>
      <input name="estimatedCost" value={form.estimatedCost} onChange={handleChange} type="number" min="0" step="0.01" />
      <label>Fund</label>
      <select name="fund" value={form.fund} onChange={handleChange} required>
        <option value="">Select</option>
        <option value="ADMN">ADMN</option>
        <option value="CW">CW</option>
        <option value="NA">NA</option>
      </select>
      <label>Target Date</label>
      <input name="targetQtr" type="date" value={form.targetQtr} onChange={handleChange} />
      <label>Status</label>
      <select name="status" value={form.status} onChange={handleChange} required>
        <option value="">Select</option>
        <option value="Open">Open</option>
        <option value="In Progress">In Progress</option>
        <option value="Closed">Closed</option>
      </select>
      <button type="submit">{editingIssue ? 'Update' : 'Register'}</button>
      {editingIssue && <button type="button" onClick={onCancel}>Cancel</button>}
    </form>
  );
}
